var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "10px 10px 0px 10px", background: "white" } },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { background: "white" },
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$i18n.t("common.RegisteredUser"),
                name: "first"
              }
            },
            [_c("registerUser")],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: { label: _vm.$i18n.t("common.GuestUser"), name: "second" }
            },
            [_c("touristUser")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }